import { render, staticRenderFns } from "./uitimateHealthPdf.vue?vue&type=template&id=32dc554a&scoped=true&"
import script from "./uitimateHealthPdf.vue?vue&type=script&lang=js&"
export * from "./uitimateHealthPdf.vue?vue&type=script&lang=js&"
import style0 from "./uitimateHealthPdf.vue?vue&type=style&index=0&id=32dc554a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc554a",
  null
  
)

export default component.exports